var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex justify-center items-center"},[_c('img',{attrs:{"src":require('~/assets/img/rolling-ring.svg'),"alt":"Loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }